<template>
  <div class="root" :style="{ backgroundImage: `url(${backgroundUrl})` }">
    <div class="head">
      <div class="enterprise-logo">
        <div class="tjls-logo" v-if="userInfo.tenantId === 133">
          <img class="tjls-logo-left" src="@/assets/images/tjls/tjls-logo-left.png" alt="tjls-logo">
          <img class="tjls-logo-right" src="@/assets/images/tjls/tjls-logo-right.png" alt="tjls-logo">
        </div>
        <img v-if="bgUrl && userInfo.tenantId !== 133" class="logo" :src="bgUrl" />
      </div>
    </div>
    <div class="body">
      <div class="list">
        <div class="list_item" v-for="(item, index) in permissionsInfo" :key="index"
        >
          <div
            class="common"
            :style="{
              backgroundColor: backgroundColor[index % backgroundColor.length],
              color: color[index % color.length],
            }"
            @click="handleClick(item)">
            <div class="rectangle">
              <div class="all-icon" :style="{ color: color[index % color.length] }">
                <svg-icon :icon-class="item.icon"></svg-icon>
              </div>
              <div class="title">
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="tjls-bottom" v-if="userInfo.tenantId === 133">
        <img class="tjls-logo-right" src="@/assets/images/tjls/tjls-logo-bottom.png" alt="tjls-logo">
      </div>
    </div>
  </div></template>

<script>
import { mapGetters } from 'vuex'
import { indexConfig } from '@/api/auth'
import { getHomeBackgroundUrl } from '@/utils/preloadHomeBackground'
export default {
  data () {
    return {
      bgUrl: ''
    }
  },
  mounted () {
    setTimeout(() => {
      if (this.permissionsInfo.length === 1) {
        this.$router.push({ path: this.permissionsInfo[0].url })
      } else {
        const params = {
          tenantId: this.userInfo.tenantId,
          ruleTypes: ['mobile_title', 'mobile_home_pic']
        }
        indexConfig(params).then((res) => {
          this.bgUrl = res.data.mobile_home_pic
        })
      }
    }, 200)
  },
  computed: {
    ...mapGetters(['permissionsInfo', 'userInfo']),
    backgroundUrl () {
      return getHomeBackgroundUrl(this.userInfo.tenantId)
    },
    backgroundColor () {
      if (this.userInfo.tenantId === 133) {
        return [
          '#daa0ff',
          '#007baf',
          '#6077ff',
          '#ff8100'
        ]
      } else {
        return [
          '#bad6fd',
          '#fee2ab',
          '#b5e5f6',
          '#becbf5',
          '#a8e8d3',
          '#f5efbe',
          '#fddee3'
        ]
      }
    },
    color () {
      if (this.userInfo.tenantId === 133) {
        return [
          '#ffffff',
          '#ffffff',
          '#ffffff',
          '#ffffff'
        ]
      } else {
        return [
          '#4371ae',
          '#9f7629',
          '#4390ab',
          '#435cae',
          '#29a079',
          '#afa231',
          '#e36d80'
        ]
      }
    }
  },
  methods: {
    handleClick (item) {
      if (item.meta.unClick) {
        return true
      } else {
        this.$router.push({ path: item.url })
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.name === 'visitSuccess' || from.name === 'terminalVisitMap') {
      to.meta.isUseCache = false
      next()
    } else {
      to.meta.isUseCache = true
      next()
    }
  },
  beforeRouteLeave (to, from, next) {
    if (from.meta.isUseCache === false) {
      to.meta.keepAlive = false
      next()
    } else {
      to.meta.keepAlive = true
      next()
    }
  }
}
</script>

<style lang="stylus" scoped>
.root {
  width: 750px;
  height 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center top;
  text-align: center;
  overflow: hidden;
    .head {
        width: 100%;
        text-align: center;
        .enterprise-logo {
          margin: 0 auto;
          width: 510px;
          height: 268px;
          padding-top: 60px;
          padding-bottom: 40px;
          .tjls-logo {
            width: 100%;
            height: 100px;
            display: flex;
            justify-content: center;
            align-items: center;
              .tjls-logo-left {
                width: 232px;
                height: 56px;
                margin-right: 10px;
              }
              .tjls-logo-right {
                width: 236px;
                height: 64px;
                margin-left: 10px;
              }
            }
          .logo {
            height: 100%;
            width: 100%;
          }
        }
    }
    .body {
        height: calc(100% - 600px)
        overflow-y: scroll;
        .list {
            width: 560px;
            padding-top: 20px;
            margin: 20px 95px 0;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            &_item{
                display: flex;
                margin-bottom: 30px;
                .common {
                  display:flex;
                  flex: 1;
                  height: 230px;
                  margin: auto;
                  text-align: center;
                  box-shadow: 0px 0px 20px 0px rgba(43, 79, 153, 0.2);
                  border-radius: 14px;
                  .rectangle{
                    margin: auto;
                    .all-icon {
                      margin: 0 70px;
                      height: 116px;
                      width: 125px;
                        font-size: 80px;
                          .icon {
                            height: 100%;
                            width: 100%;
                          }
                        }
                    .title {
                      font-size: 32px;
                      line-height: 60px;
                      margin: 0 45px;
                    }
                  }
                }
            }
        }
    }
    .footer {
      position: relative;
      height: 400px;
      .tjls-bottom {
        position: absolute;
        bottom: 304px;
        left: 88px;
        width: 216px;
        height: 42px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
}

</style>
